globalThis.backoffice = globalThis.backoffice || {};

backoffice.Contacts = (function()
{
  function Contacts($container) {
    this.events();
  }

  Contacts.prototype = {
    events: function() {
      var $communicationChannelPreferencesPanel = $('.communication-channel-preferences-panel');
      var $allCommunicationsSwitchery           = $communicationChannelPreferencesPanel.find('.all-communications-switchery');
      var $communicationChannelPreferencesList  = $communicationChannelPreferencesPanel.find('.communication-channel-preferences-list');
      var $form                                 = $communicationChannelPreferencesPanel.closest('form');
      var $allCommunicationsChannelStatusInput  = $form.find('.all-communications-channel-status-input');

      $allCommunicationsSwitchery.on('change', 'input[type=checkbox]', function(e) {
          e.preventDefault();
          var $checkbox = $(this);

          if($checkbox.is(':checked')) {
              $communicationChannelPreferencesList.show();
              $allCommunicationsChannelStatusInput.val("realtime");
          } else {
              $communicationChannelPreferencesList.hide();
              $allCommunicationsChannelStatusInput.val("disabled");
          }
      });

      var $greetingFormatSelect = $('.greeting-format-select');
      var $contactForm          = $greetingFormatSelect.closest('form');

      $contactForm.on('input change', '[name="contact[firstname]"], [name="contact[lastname]"], [name="contact[salutation]"], [name="contact[gender]"]', function() {
          var defaults   = $greetingFormatSelect.data();
          var capitalize = function(value) { return value.charAt(0).toUpperCase() + value.slice(1); };
          var firstname  = $.trim($contactForm.find('[name="contact[firstname]"]').val()) || defaults.defaultFirstname;
          var lastname   = $.trim($contactForm.find('[name="contact[lastname]"]').val()) || defaults.defaultLastname;
          var gender     = $contactForm.find('[name="contact[gender]"]:checked').val();
          var salutation = $.trim($contactForm.find('[name="contact[salutation]"]').val()) || defaults.genderTitles[gender];
          var examples   = {
              first_name: 'Bonjour ' + capitalize(firstname),
              salutation_last_name: salutation ? 'Bonjour ' + salutation + ' ' + capitalize(lastname) : 'Bonjour,'
          };

          $greetingFormatSelect.find('option').each(function() {
              var $option = $(this);
              $option.text($option.data('label') + ' (« ' + examples[$option.val()] + ' »)').removeData('data');
          });

          $greetingFormatSelect.trigger('change.select2');
      });
    }
  }

  return Contacts;
})();
